import {
  DomainAPI,
  Channel,
  Token,
  APIKey,
  Authorization,
  TokenExpires,
  Role,
  generateKey,
  _pick,
} from "../utils/setting";
import { checkResponse } from "../utils/checkResponse";
import jwt from "jsonwebtoken";
import { Cookies } from "react-cookie";

const cookie = new Cookies();
const user = {
  state: {
    allUser: [],
    allOwnerRole: [],
    total: 0,
    count: 0,
    token: cookie.get(Token) || "",
    user: {
      email: null,
      username: null,
      password: null,
      countryCode: "+84",
      roleId: {
        role: "user",
        loginAdmin: 0, //0 la khong cho login
        loginFrontend: 1,
        module: {},
      },
      firstName: "",
      lastName: "",
      fullName: "",
      avatarImage: "",
      dob: "",
      sex: "",
      address: "",
    },
    password: {
      currentPassword: "",
      newPassword: "",
      confirmNewPassword: "",
    },
    loading: false,
    stateLogin: !!cookie.get(Token),
    checkActiveCode: false,
    errorCodeLogin: "",
    findUserforAdmin: {},
    selectRole: [],
    module: {},
  },
  reducers: {
    setState(state, payload) {
      state = { ...state, ...payload };
      return { ...state };
    },
  },
  effects: (dispatch) => ({
    createServiceForOwner(payload = {}, rootState) {
      return fetch(DomainAPI + Channel + "/api/public/users/registerOwnerSpa", {
        method: "POST",
        headers: {
          [APIKey]: generateKey(),
          "Content-type": "application/json",
        },
        body: JSON.stringify(payload.spa),
      })
        .then((res) => res.json())
        .then((result) => {
          if (result.code === 1) {
            return true;
          } else {
            if (payload.snackbar)
              payload.snackbar(result.message || "Something went wrong");
            return false;
          }
        })
        .catch((err) => {
          if (payload.snackbar)
            payload.snackbar(err.message || "Something went wrong");
          return false;
        });
    },
    checkOwnerSpa(payload = {}, rootState) {
      let url = DomainAPI + Channel + "/api/public/users/checkOwnerSpa";

      return fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          [APIKey]: generateKey(),
        },
        body: JSON.stringify(payload.spa),
      })
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          if (result.code == 0) {
            if (result.error === 1146) {
              if (payload.snackbar)
                payload.snackbar(payload.t("spa_disabled_pls_contact_admin"));
              return {
                success: false,
              };
            } else if (result.error === 1011 || result.error === 1139) {
              /*
                        1011: ERROR_NOT_FOUND_USER => chưa có tài khoản
                        1139: USER_ROLE_NOT_FOUND => Chưa có tài khoản
                        1143: SPA_NOT_FOUND => chưa có role ownerSpa
                        1182: NOT_FOUND_OWNER_SPA => chưa có role ownerSpa 
                    */
              return {
                ...result,
                userExisted: false,
                success: true,
              };
            } else if (result.error == 1143 || result.error == 1182) {
              return {
                ...result,
                userExisted: true,
                success: true,
              };
            } else {
              return {
                success: false,
                message: result.message,
                error: result.error,
              };
            }
          } else {
            if (payload.snackbar) payload.snackbar(payload.t("spa_exist"));
            return {
              success: false,
              message: "User is exist",
              error: result.error,
            };
          }
        })
        .catch((error) => {
          return {
            success: false,
            message: error.message,
            error: error,
          };
        });
    },
    async set(payload, rootState) {
      //check login
      if (rootState.user.token) {
        let decode = await jwt.decode(rootState.user.token);
        decode = JSON.parse(decode.data);
        decode.roleId = JSON.parse(decode.roleId);
        if (decode.roleId && decode.roleId.loginAdmin === 1) {
          this.setState({ user: decode, stateLogin: true });
          return true;
        } else {
          this.setState({ stateLogin: false });
          return false;
        }
      } else {
        this.setState({ stateLogin: false });
        return false;
      }
    },
    async login(payload = {}, rootState) {
      const _this = this;
      return fetch(DomainAPI + Channel + "/api/public/users/login", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          [APIKey]: generateKey(),
        },
        body: JSON.stringify({
          username: payload.user.username,
          password: payload.user.password,
          countryCode: payload.user.countryCode,
          role: payload.role || "",
        }),
      })
        .then((res) => res.json())
        .then(async (result) => {
          if (result.code === 1) {
            cookie.set(Token, result.data, {
              path: "/",
              expires: new Date(Date.now() + TokenExpires),
            });
            let decode = await jwt.decode(result.data);
            decode = JSON.parse(decode.data);
            decode.roleId = JSON.parse(decode.roleId);
            decode.lastName = decode.lastName.trim() || "";
            decode.firstName = decode.firstName.trim() || "";
            result.dataUser = decode;
            cookie.set(Role, decode.roleId && decode.roleId.role, {
              path: "/",
              expires: new Date(Date.now() + TokenExpires),
            });
            _this.setState({
              token: result.data,
              stateLogin: true,
              user: decode,
            });
          }
          return result;
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.toString() };
        });
    },
    registerEmployee(payload = {}, rootState) {
      return fetch(DomainAPI + Channel + "/api/public/users/registerEmployee", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          [APIKey]: generateKey(),
        },
        body: JSON.stringify(payload.user),
      })
        .then((res) => res.json())
        .then(async (result) => {
          if (result.code === 1) {
            dispatch.serviceSetting.getServiceSetting(); // Cập nhât lại list service setting
            // if(payload.snackbar) {
            //     payload.snackbar(payload.t ? payload.t('success') : 'Success')
            // }
          } else {
            if (payload.snackbar)
              payload.snackbar(
                result.message || "Something went wrong",
                "error"
              );
          }
          return result;
        })
        .catch((error) => {
          if (payload.snackbar)
            payload.snackbar(error.message || "Something went wrong", "error");
          return { code: 0, error: error, message: error.toString() };
        });
    },
    async reLogin(payload = {}, rootState) {
      let token = cookie.get(Token);
      const _this = this;
      if (token) {
        return fetch(DomainAPI + Channel + "/api/secure/users/reLogin", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            [APIKey]: generateKey(),
            [Authorization]: token,
          },
        })
          .then((res) => res.json())
          .then(async (result) => {
            checkResponse(result, dispatch);
            if (
              result.code === 1 &&
              result.data.user &&
              result.data.user.roleId
            ) {
              let roleId = result.data.user.roleId || {};
              if (roleId.loginAdmin === 1) {
              } else {
                if (payload.snackbar)
                  payload.snackbar(
                    "login_you_havent_registered_a_masspa_in_system_so_you_can_not_access_admin_page_lets_click_sign_up",
                    "error"
                  );
                _this.setState({ stateLogin: false });
                payload.push("/signin");
                return false;
              }
            } else {
              if (payload.snackbar)
                payload.snackbar(result.message || "User not found", "error");
              _this.setState({ stateLogin: false });
              payload.push("/signin");
              return false;
            }
          })
          .catch((err) => {
            if (payload.snackbar) payload.snackbar(err.message, "error");
            _this.setState({ stateLogin: false });
            payload.push("/signin");
            return false;
          });
      } else {
        if (payload.snackbar) payload.snackbar("Not found token", "error");
        this.setState({ stateLogin: false });
        payload.push("/signin");
        return false;
      }
    },
    logout(payload, rootState) {
      dispatch.fcm.disconnectFCM(cookie.get(Token));
      cookie.remove(Token);
      this.setState({ stateLogin: false, token: null, module: {} });
      payload.push("/signin");
    },
    async updateImgURL(payload, rootState) {
      const _this = this;
      return fetch(DomainAPI + Channel + "/api/secure/users/updateAvatar", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          [APIKey]: generateKey(),
          [Authorization]: rootState.user.token,
        },
        body: JSON.stringify({
          url: payload.avatarImage,
          imgPre: payload.imgPre,
          roleId: rootState.user.user.roleId,
        }),
      })
        .then((res) => res.json())
        .then(async (result) => {
          checkResponse(result, dispatch);
          if (result.code === 1) {
            cookie.set(Token, result.data, {
              path: "/",
              expires: new Date(Date.now() + TokenExpires),
            });
            let decode = await jwt.decode(result.data);
            decode = JSON.parse(decode.data);
            decode.roleId = JSON.parse(decode.roleId);
            _this.setState({ user: decode, token: result.data });
          }
          return result.code === 1 ? true : false;
        })
        .catch((err) => {
          return false;
        });
    },
    async changePassword(payload, rootState) {
      const _this = this;
      return fetch(DomainAPI + Channel + "/api/secure/users/changePassword", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          [APIKey]: generateKey(),
          [Authorization]: rootState.user.token,
        },
        body: JSON.stringify(payload),
      })
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          return result;
        })
        .catch((err) => {
          return { code: 0, error: err, message: err.toString() };
        });
    },
    async updateUser(payload, rootState) {
      const _this = this;
      payload = { ...payload, ...{ roleId: rootState.user.user.roleId } };

      return fetch(DomainAPI + Channel + "/api/secure/users/updateUser", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          [APIKey]: generateKey(),
          [Authorization]: rootState.user.token,
        },
        body: JSON.stringify(payload),
      })
        .then((res) => res.json())
        .then(async (result) => {
          checkResponse(result, dispatch);
          if (result.code === 1) {
            _this.setState({ token: result.data });
            cookie.set(Token, result.data, {
              path: "/",
              expires: new Date(Date.now() + TokenExpires),
            });
            let decode = await jwt.decode(result.data);
            decode = JSON.parse(decode.data);
            decode.roleId = JSON.parse(decode.roleId);
            decode.lastName = decode.lastName.trim() || "";
            decode.firstName = decode.firstName.trim() || "";
            _this.setState({ user: decode });
          }
          return result;
        })
        .catch((err) => {
          return { code: 0, error: err, message: err.message };
        });
    },
    forgetPassword(payload, rootState) {
      const _this = this;
      return fetch(DomainAPI + Channel + "/api/public/users/forgetPassword", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          [APIKey]: generateKey(),
        },
        body: JSON.stringify(
          _pick(payload, [
            "username",
            "password",
            "activeCode",
            "countryCode",
            "confirmPassword",
          ])
        ),
      })
        .then((res) => res.json())
        .then(function (result) {
          return result;
        })
        .catch((err) => {
          return { code: 0, error: err, message: err.message };
        });
    },
    async findUserforAdmin(payload, rootState) {
      let _this = this;
      return fetch(DomainAPI + Channel + "/api/secure/users/findUserforAdmin", {
        method: "POST",
        body: JSON.stringify(payload),
        headers: {
          "Content-Type": "application/json",
          [APIKey]: generateKey(),
          [Authorization]: rootState.user.token,
        },
      })
        .then((res) => res.json())
        .then(function (result) {
          checkResponse(result, dispatch);
          if (result.code === 1)
            _this.setState({ findUserforAdmin: result.data });
          return result.code === 1 ? true : false;
        })
        .catch((err) => {
          return false;
        });
    },
    async addOwnerSpa(payload, rootState) {
      let _this = this;
      return fetch(DomainAPI + Channel + "/api/secure/users/addOwnerSpa", {
        method: "POST",
        body: JSON.stringify(payload),
        headers: {
          "Content-Type": "application/json",
          [APIKey]: generateKey(),
          [Authorization]: rootState.user.token,
        },
      })
        .then((res) => res.json())
        .then(function (result) {
          checkResponse(result, dispatch);
          return result;
        })
        .catch((err) => {
          return { code: 0, error: err, message: err.message };
        });
    },
    async removeOwnerSpa(payload, rootState) {
      let _this = this;
      return fetch(DomainAPI + Channel + "/api/secure/users/removeOwnerSpa", {
        method: "POST",
        body: JSON.stringify(payload),
        headers: {
          "Content-Type": "application/json",
          [APIKey]: generateKey(),
          [Authorization]: rootState.user.token,
        },
      })
        .then((res) => res.json())
        .then(function (result) {
          checkResponse(result, dispatch);
          return result;
        })
        .catch((err) => {
          return { code: 0, error: err, message: err.message };
        });
    },
    getAllUser(payload, rootState) {
      let _this = this;
      return fetch(DomainAPI + Channel + "/api/secure/users/getAllUser", {
        method: "POST",
        body: JSON.stringify(payload),
        headers: {
          "Content-Type": "application/json",
          [APIKey]: generateKey(),
          [Authorization]: rootState.user.token,
        },
      })
        .then((res) => res.json())
        .then(function (res) {
          checkResponse(res);
          if (res.code === 1) {
            if (res.data && res.data.allOwnerRole) {
              dispatch.service.findByUserCode({
                codes: res.data.allOwnerRole,
              });
            }
            _this.setState({
              allUser: res.data.list,
              allOwnerRole: res.data.allOwnerRole,
              total: res.data.total,
              count: res.data.count,
            });
          }
          return res;
        })
        .catch((err) => {
          return { code: 0, error: err, message: err.message };
        });
    },
    getInfoOwnerSpa(payload, rootState) {
      let _this = this;
      return fetch(DomainAPI + Channel + "/api/secure/users/getInfoOwnerSpa", {
        method: "POST",
        body: JSON.stringify(payload),
        headers: {
          "Content-Type": "application/json",
          [APIKey]: generateKey(),
          [Authorization]: rootState.user.token,
        },
      })
        .then((res) => res.json())
        .then(function (res) {
          checkResponse(res);
          return res;
        })
        .catch((err) => {
          return { code: 0, error: err, message: err.message };
        });
    },
    getModuleRoleForWeb(payload, rootState) {
      let _this = this;
      return fetch(
        DomainAPI + Channel + "/api/secure/users/getModuleRoleForWeb",
        {
          method: "POST",
          // body: JSON.stringify(payload),
          headers: {
            "Content-Type": "application/json",
            [APIKey]: generateKey(),
            [Authorization]: rootState.user.token,
          },
        }
      )
        .then((res) => res.json())
        .then(function (res) {
          if (res.code === 1 && res.data) _this.setState({ module: res.data });
          checkResponse(res);
          return res;
        })
        .catch((err) => {
          console.log(err);
          return { code: 0, error: err, message: err.message };
        });
    },
    updateStatusUser(payload, rootState) {
      return fetch(DomainAPI + Channel + "/api/secure/users/updateStatusUser", {
        method: "POST",
        body: JSON.stringify(payload),
        headers: {
          "Content-Type": "application/json",
          [APIKey]: generateKey(),
          [Authorization]: rootState.user.token,
        },
      })
        .then((res) => res.json())
        .then(function (res) {
          checkResponse(res);
          return res;
        })
        .catch((err) => {
          return { code: 0, error: err, message: err.message };
        });
    },
    decodeCodeInvite(payload, rootState) {
      return fetch(DomainAPI + Channel + "/api/public/users/decodeCodeInvite", {
        method: "POST",
        body: JSON.stringify(payload),
        headers: {
          "Content-Type": "application/json",
          [APIKey]: generateKey(),
          // [Authorization]: rootState.user.token,
        },
      })
        .then((res) => res.json())
        .then(function (res) {
          checkResponse(res);
          return res;
        })
        .catch((err) => {
          return { code: 0, error: err, message: err.message };
        });
    },
  }),
};

export default user;
